// All tours are stored in one flat array. Each tour has its own detail page at /tours/:id
export const tours = [
  // ================= ADVENTURE =================
  {
    id: 'bhairav-gorakh',
    title: 'Bhairav Ghad & Gorakh Ghad',
    location: 'Malshej Ghat, Maharashtra',
    duration: 'Fri afternoon – Sun evening',
    price: 7999,
    difficulty: 'Challenging',
    groupSize: '6-14',
    rating: 4.9,
    reviews: 42,
    image: 'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg',
    gallery: [
      'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg',
      'https://images.unsplash.com/photo-1707840422122-268356e197c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
      'https://images.unsplash.com/photo-1762717564665-234cd54392df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Adventure',
    tag: 'Weekend Escape',
    short: 'Two Sahyadri legends in one long weekend \u2014 a 200 ft rappel at Bhairav Ghad on Saturday and a classic rock trek to Gorakh Ghad on Sunday, based out of misty Malshej Ghat.',
    experiences: [
      { title: 'Bhairav Ghad', subtitle: 'Trek + Rappelling', day: 'Saturday', image: 'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg', summary: 'A 2-hour uphill trek followed by a supervised rope-and-harness rappel down the cliff face with certified guides.', features: ['~2 hour uphill trek', 'Full safety-gear rappel', 'Certified guides', 'Summit ridge'] },
      { title: 'Gorakh Ghad', subtitle: 'Trek + Fort Exploration', day: 'Sunday', image: 'https://images.unsplash.com/photo-1707840422122-268356e197c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600', summary: 'A moderately steep rock-cut trek with an iron-ladder finish. Explore ancient summit caves and stunning views of Siddhagad valley.', features: ['~2 hour uphill trek', 'Rock-cut caves', 'Iron ladder climb', 'Valley views'] }
    ],
    highlights: ['Bhairav Ghad rappelling (\u20b91,000 activity included)', 'Gorakh Ghad rock-cut trek', '1-night stay at misty Malshej Ghat', 'Bengaluru\u2013Pune 3A train tickets', 'Tempo Traveller throughout Maharashtra', 'Certified trek guides & full safety gear'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Pune \u2192 Malshej Ghat \u2192 Bhairav Ghad \u2192 Gorakh Ghad \u2192 Pune', stay: '1 night at Malshej Ghat', transport: 'Train Bengaluru\u2013Pune (3A) + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Friday \u2014 Departure from Bengaluru', desc: 'Meet at Bengaluru railway station and board the overnight Pune-bound train.' },
      { day: 2, title: 'Saturday \u2014 Bhairav Ghad rappelling', desc: 'Arrive Pune \u2192 drive to Malshej Ghat \u2192 leave at 5 AM \u2192 2-hour trek \u2192 rappelling \u2192 summit exploration \u2192 descent \u2192 lunch \u2192 overnight stay.' },
      { day: 3, title: 'Sunday \u2014 Gorakh Ghad Fort', desc: 'Start trek by 6 AM \u2192 2-hour climb \u2192 explore fort, caves and summit \u2192 descent \u2192 lunch \u2192 Pune drop by evening.' }
    ],
    includes: ['Bengaluru\u2013Pune 3A train ticket', 'Tempo Traveller & all transport', '1-night Malshej Ghat stay', 'Meals during the trip', 'Certified trek guides', 'Bhairav Ghad rappelling activity (\u20b91,000 value)', 'Local travel & parking', 'Basic trek coordination'],
    excludes: ['Return flight from Pune', 'Personal expenses', 'Extra snacks/drinks', 'Travel insurance', 'Anything not specifically mentioned'],
    priceNote: 'Price calculated for group travel with shared accommodation and transport. Final price may vary based on group size and train/hotel availability.'
  },
  {
    id: 'badami-dandeli',
    title: 'Badami & Dandeli',
    location: 'North Karnataka',
    duration: '3 Days / 2 Nights',
    price: 8499,
    difficulty: 'Moderate',
    groupSize: '6-14',
    rating: 4.8,
    reviews: 38,
    image: 'https://images.unsplash.com/photo-1621693113354-8b32a9e0ba39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1621693113354-8b32a9e0ba39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
      'https://images.unsplash.com/photo-1688098224371-b4717b2f72ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Adventure',
    tag: 'Signature',
    short: 'A rappel-and-raft combo across North Karnataka \u2014 red sandstone cliffs of Badami by day, white-water on the Kali river at Dandeli by dusk.',
    highlights: ['Sandstone rappelling at Badami', 'Chalukyan cave temples', 'Grade II-III Kali river rapids', 'Coracle ride & kayaking', 'Dandeli jungle jeep safari', 'Riverside cottage stay'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Badami \u2192 Dandeli \u2192 Bengaluru', stay: '2 nights (Badami + Dandeli)', transport: 'Overnight bus + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Bengaluru \u2192 Badami', desc: 'Overnight bus to Badami. Rappelling on the red cliffs and cave temple exploration.' },
      { day: 2, title: 'Badami \u2192 Dandeli', desc: 'Drive to Dandeli, evening river walk and campfire.' },
      { day: 3, title: 'Dandeli adventures \u2192 Bengaluru', desc: 'White-water rafting, coracle & jungle safari before the overnight return.' }
    ],
    includes: ['All transport ex-Bengaluru', '2-night stay', 'Breakfast & dinner', 'Rappelling & rafting fees', 'Trip captain'],
    excludes: ['Personal expenses', 'Lunches', 'Travel insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'nashik-trails',
    title: 'Nashik Trails \u2014 Harihar Fort & Harishchandragad',
    location: 'Nashik & Ahmednagar, Maharashtra',
    duration: '3 Days / 2 Nights',
    price: 6999,
    difficulty: 'Challenging',
    groupSize: '6-14',
    rating: 4.9,
    reviews: 56,
    image: 'https://images.pexels.com/photos/33304432/pexels-photo-33304432.jpeg',
    gallery: [
      'https://images.pexels.com/photos/33304432/pexels-photo-33304432.jpeg',
      'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg'
    ],
    category: 'Adventure',
    tag: 'Trekker\u2019s Pick',
    short: 'Two of the Sahyadris\u2019 most iconic climbs in one loop \u2014 the vertigo-inducing 90\u00b0 steps of Harihar Fort and the legendary Konkan Kada cliff at Harishchandragad.',
    highlights: ['Harihar\u2019s 90\u00b0 rock-cut steps', 'Sunrise at Konkan Kada', 'Kedareshwar cave', 'Overnight camp near the base village', 'Trimbak valley views'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Nashik \u2192 Harihar \u2192 Harishchandragad \u2192 Nashik', stay: '2 nights base-village homestay', transport: 'Train + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Arrival & Harihar climb', desc: 'Reach Nashik and drive to Harihar base. Climb the iconic 90\u00b0 rock-cut stairs.' },
      { day: 2, title: 'Harishchandragad trek', desc: 'Trek to Konkan Kada, visit Kedareshwar cave and Taramati peak. Overnight at base.' },
      { day: 3, title: 'Return', desc: 'Descend and drive back to Nashik for the evening train.' }
    ],
    includes: ['Return train tickets', 'Local transport', 'Homestay + meals', 'Certified trek guides', 'Basic first-aid'],
    excludes: ['Personal expenses', 'Snacks', 'Travel insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },

  // ================= NATURE =================
  {
    id: 'shivamogga-sagara',
    title: 'Shivamogga & Sagara Trails',
    location: 'Shivamogga, Karnataka',
    duration: '3 Days / 2 Nights',
    price: 6999,
    difficulty: 'Easy-Moderate',
    groupSize: '6-14',
    rating: 4.8,
    reviews: 61,
    image: 'https://images.unsplash.com/photo-1660294534711-75a9474fecb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1660294534711-75a9474fecb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
      'https://images.pexels.com/photos/11170475/pexels-photo-11170475.jpeg'
    ],
    category: 'Nature',
    tag: 'Waterfalls',
    short: 'Chase four wildly different cascades in one weekend \u2014 the mighty Jog Falls, hidden Dabbe Falls, Bhimeshwara jungle pools and the peak sunrise at Kodachadri.',
    highlights: ['Jog Falls \u2014 India\u2019s tallest plunge falls', 'Dabbe Falls jeep + trek', 'Bhimeshwara jungle temple', 'Kodachadri sunrise', 'Sharavathi backwaters'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Sagara \u2192 Jog \u2192 Dabbe \u2192 Kodachadri \u2192 Bengaluru', stay: '2 nights homestay', transport: 'Overnight bus + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Arrival at Sagara', desc: 'Drive to Jog Falls, viewpoint walk and evening at homestay.' },
      { day: 2, title: 'Dabbe & Bhimeshwara', desc: 'Jeep + trek to Dabbe Falls, afternoon at Bhimeshwara.' },
      { day: 3, title: 'Kodachadri & return', desc: 'Early sunrise trek at Kodachadri before returning to Bengaluru.' }
    ],
    includes: ['Round-trip transport', 'Homestay + meals', 'All entry fees', 'Local trek guides'],
    excludes: ['Personal expenses', 'Lunches en route', 'Travel insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'sirsi-trails',
    title: 'Sirsi Trails',
    location: 'Sirsi, Karnataka',
    duration: '2 Days / 1 Night',
    price: 6499,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.7,
    reviews: 47,
    image: 'https://images.pexels.com/photos/15596733/pexels-photo-15596733.jpeg',
    gallery: [
      'https://images.pexels.com/photos/15596733/pexels-photo-15596733.jpeg',
      'https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Nature',
    tag: 'Rainforest',
    short: 'A rainforest loop around Sirsi \u2014 the thunder of Unchalli Falls, secluded Vibhuti Falls and the black limestone monoliths of Yana Caves.',
    highlights: ['Yana Caves twin monoliths', 'Vibhuti Falls', 'Unchalli 116 m plunge', 'Rainforest walks', 'Sirsi homestay dinner'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Sirsi \u2192 Yana \u2192 Unchalli \u2192 Bengaluru', stay: '1 night homestay', transport: 'Overnight bus + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Sirsi arrival', desc: 'Reach Sirsi, visit Yana caves and Vibhuti Falls. Evening homestay.' },
      { day: 2, title: 'Unchalli & return', desc: 'Morning trek to Unchalli viewpoint. Return by evening bus.' }
    ],
    includes: ['Round-trip transport', 'Homestay + meals', 'Entry fees', 'Guide'],
    excludes: ['Personal expenses', 'Snacks', 'Travel insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'samse-trails',
    title: 'Samse Trails \u2014 Gangadikal & Kudremukha',
    location: 'Chikkamagaluru, Karnataka',
    duration: '3 Days / 2 Nights',
    price: 6999,
    difficulty: 'Moderate',
    groupSize: '6-14',
    rating: 4.8,
    reviews: 39,
    image: 'https://images.pexels.com/photos/11170475/pexels-photo-11170475.jpeg',
    gallery: [
      'https://images.pexels.com/photos/11170475/pexels-photo-11170475.jpeg',
      'https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Nature',
    tag: 'Grassland Trek',
    short: 'Gentle rolling grasslands, mist-swept peaks and old coffee estates \u2014 the Kudremukha traverse from Samse village is one of the softest big-mountain days in the Western Ghats.',
    highlights: ['Kudremukha peak trek', 'Gangadikal viewpoint', 'Samse homestay', 'Estate walks', 'Ontimara solo tree'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Samse \u2192 Kudremukha \u2192 Bengaluru', stay: '2 nights homestay', transport: 'Overnight bus + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Samse arrival', desc: 'Reach Samse, coffee estate walk, evening bonfire.' },
      { day: 2, title: 'Kudremukha trek', desc: 'Full-day trek to the peak, packed lunch on the way.' },
      { day: 3, title: 'Gangadikal & return', desc: 'Morning at Gangadikal viewpoint before the return.' }
    ],
    includes: ['Round-trip transport', 'Homestay + meals', 'Trek permits', 'Guide'],
    excludes: ['Personal expenses', 'Insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'malshej-trails',
    title: 'Malshej Ghat Trails',
    location: 'Malshej Ghat, Maharashtra',
    duration: '2 Days / 1 Night',
    price: 4999,
    difficulty: 'Moderate',
    groupSize: '6-14',
    rating: 4.7,
    reviews: 44,
    image: 'https://images.pexels.com/photos/9817689/pexels-photo-9817689.jpeg',
    gallery: [
      'https://images.pexels.com/photos/9817689/pexels-photo-9817689.jpeg',
      'https://images.unsplash.com/photo-1626715185400-49cccfabc10f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Nature',
    tag: 'Monsoon Only',
    short: 'A monsoon combo \u2014 stand under Maharashtra\u2019s mightiest 1200 ft Kalu Falls and watch water fly upwards at Naneghat\u2019s Reverse Waterfalls in the same trip.',
    highlights: ['Kalu Falls 1200 ft cascade', 'Reverse Waterfalls at Naneghat', 'Malshej plateau walks', 'Pink flamingos (season)', 'Monsoon-only magic'],
    tripInfo: { startingPoint: 'Pune', route: 'Pune \u2192 Malshej Ghat \u2192 Naneghat \u2192 Pune', stay: '1 night at Malshej Ghat', transport: 'Tempo Traveller from Pune' },
    itinerary: [
      { day: 1, title: 'Malshej arrival + Kalu Falls', desc: 'Drive to Malshej. Trek to Kalu Falls in the afternoon. Overnight stay.' },
      { day: 2, title: 'Reverse Falls & return', desc: 'Morning at Naneghat\u2019s Reverse Falls, packed lunch and return.' }
    ],
    includes: ['Local transport from Pune', 'Stay + meals', 'Trek guide', 'Basic first-aid'],
    excludes: ['Travel to Pune', 'Personal expenses', 'Insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'waterfalls-trails',
    title: 'Waterfalls Trails \u2014 Kumbhe, Nanemachi, Satsada, Devkund, Savlya Ghat',
    location: 'Raigad \u2014 Konkan, Maharashtra',
    duration: '4 Days / 3 Nights',
    price: 7499,
    difficulty: 'Moderate',
    groupSize: '6-14',
    rating: 4.9,
    reviews: 52,
    image: 'https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
      'https://images.unsplash.com/photo-1610044847457-f6aabcbb67d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Nature',
    tag: 'Konkan Circuit',
    short: 'A five-waterfall Konkan expedition \u2014 Devkund\u2019s emerald plunge pool, the untouched Nanemachi trek, roaring Kumbhe and the hidden Savlya Ghat, all in one long weekend.',
    highlights: ['Devkund emerald plunge', 'Kumbhe Falls trek', 'Nanemachi rainforest', 'Satsada tiered cascade', 'Savlya Ghat viewpoint'],
    tripInfo: { startingPoint: 'Pune', route: 'Pune \u2192 Kumbhe \u2192 Nanemachi \u2192 Satsada \u2192 Devkund \u2192 Savlya Ghat \u2192 Pune', stay: '3 nights homestay', transport: 'Tempo Traveller from Pune' },
    itinerary: [
      { day: 1, title: 'Pune \u2192 Kumbhe', desc: 'Drive to Kumbhe, evening walk to the falls.' },
      { day: 2, title: 'Nanemachi & Satsada', desc: 'Full-day trek to Nanemachi followed by Satsada in the afternoon.' },
      { day: 3, title: 'Devkund', desc: 'Trek to Devkund\u2019s emerald plunge pool. Overnight nearby.' },
      { day: 4, title: 'Savlya Ghat & return', desc: 'Morning at Savlya Ghat viewpoint before returning to Pune.' }
    ],
    includes: ['Local transport from Pune', 'Homestay + meals', 'Trek guides', 'All permits'],
    excludes: ['Travel to Pune', 'Personal expenses', 'Insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'satara-trails',
    title: 'Satara Trails',
    location: 'Satara, Maharashtra',
    duration: '3 Days / 2 Nights',
    price: 5999,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.7,
    reviews: 68,
    image: 'https://images.unsplash.com/photo-1501761095094-94d36f57edbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1501761095094-94d36f57edbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Nature',
    tag: 'Hill Station',
    short: 'Two of Maharashtra\u2019s tallest waterfalls at Thoseghar & Vajrai combined with the strawberry hills of Mahabaleshwar \u2014 a soft, scenic weekend.',
    highlights: ['Thoseghar 500 m cascade', 'Vajrai\u2019s three-tier drop', 'Kaas Plateau of flowers', 'Mahabaleshwar viewpoints', 'Local strawberry farms'],
    tripInfo: { startingPoint: 'Pune', route: 'Pune \u2192 Satara \u2192 Mahabaleshwar \u2192 Pune', stay: '2 nights hotel', transport: 'Tempo Traveller from Pune' },
    itinerary: [
      { day: 1, title: 'Satara arrival', desc: 'Drive to Satara, visit Thoseghar Falls, evening at Kaas plateau.' },
      { day: 2, title: 'Vajrai & Mahabaleshwar', desc: 'Trek to Vajrai Falls, afternoon drive to Mahabaleshwar viewpoints.' },
      { day: 3, title: 'Return', desc: 'Morning strawberry farm visit and return to Pune.' }
    ],
    includes: ['Local transport from Pune', 'Hotel + breakfast', 'All entry fees', 'Trip captain'],
    excludes: ['Travel to Pune', 'Lunches & dinners', 'Personal expenses'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'kolhapur-trails',
    title: 'Kolhapur Trails',
    location: 'Kolhapur, Maharashtra',
    duration: '2 Days / 1 Night',
    price: 5499,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.6,
    reviews: 41,
    image: 'https://images.unsplash.com/photo-1610044847457-f6aabcbb67d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1610044847457-f6aabcbb67d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Nature',
    tag: 'Waterfalls',
    short: 'A quiet Kolhapur weekend around three lesser-known cascades \u2014 Barki\u2019s cliff cascade, Marleshwar\u2019s cave-temple falls and Ukshi\u2019s coastal drops.',
    highlights: ['Barki Falls', 'Marleshwar Falls', 'Ukshi Falls', 'Ancient cave temples', 'Kolhapur Misal breakfast'],
    tripInfo: { startingPoint: 'Kolhapur', route: 'Kolhapur \u2192 Barki \u2192 Marleshwar \u2192 Ukshi \u2192 Kolhapur', stay: '1 night homestay', transport: 'Tempo Traveller from Kolhapur' },
    itinerary: [
      { day: 1, title: 'Barki & Marleshwar', desc: 'Morning at Barki Falls, afternoon at Marleshwar cave temple falls.' },
      { day: 2, title: 'Ukshi & return', desc: 'Coastal Ukshi Falls and return to Kolhapur by evening.' }
    ],
    includes: ['Local transport', 'Homestay + meals', 'Guide'],
    excludes: ['Travel to Kolhapur', 'Personal expenses'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },

  // ================= BEACH =================
  {
    id: 'gokarna-murudeshwar',
    title: 'Gokarna & Murudeshwar',
    location: 'Coastal Karnataka',
    duration: '3 Days / 2 Nights',
    price: 7499,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.8,
    reviews: 74,
    image: 'https://images.unsplash.com/photo-1583212292454-1fe6229603b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1583212292454-1fe6229603b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Beach',
    tag: 'Coastal',
    short: 'Barefoot walks across Gokarna\u2019s four beaches, sunset at the world\u2019s second-tallest Shiva statue in Murudeshwar and quiet fishing-village dinners.',
    highlights: ['Gokarna 4-beach trek (Kudle, Om, Half-Moon, Paradise)', 'Murudeshwar Shiva statue', 'Sunset boat ride', 'Netrani snorkelling add-on', 'Coastal seafood'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Gokarna \u2192 Murudeshwar \u2192 Bengaluru', stay: '2 nights beach stay', transport: 'Overnight bus + Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Gokarna arrival', desc: 'Reach Gokarna, evening walk on Kudle beach.' },
      { day: 2, title: '4-beach trek', desc: 'Full-day walk across the four beaches. Evening seafood dinner.' },
      { day: 3, title: 'Murudeshwar & return', desc: 'Morning at Murudeshwar. Overnight bus back.' }
    ],
    includes: ['Round-trip transport', 'Beach stay + breakfast', 'Local guide', 'Sunset boat ride'],
    excludes: ['Snorkelling extras', 'Lunches & dinners', 'Personal expenses'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'kasheli-malvan',
    title: 'Kasheli & Malvan',
    location: 'Sindhudurg, Maharashtra',
    duration: '3 Days / 2 Nights',
    price: 6999,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.7,
    reviews: 33,
    image: 'https://images.unsplash.com/photo-1494783367193-149034c05e8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1494783367193-149034c05e8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Beach',
    tag: 'Konkan',
    short: 'Konkan coastal magic \u2014 Kasheli\u2019s twin waterfall drops and Malvan\u2019s Sindhudurg fort, snorkelling reefs and legendary Malvani thali.',
    highlights: ['Kasheli Waterfalls', 'Sindhudurg sea fort', 'Tarkarli scuba/snorkelling', 'Malvani thali dinner', 'Devbagh sangam boat ride'],
    tripInfo: { startingPoint: 'Pune', route: 'Pune \u2192 Kasheli \u2192 Malvan \u2192 Pune', stay: '2 nights coastal stay', transport: 'Tempo Traveller from Pune' },
    itinerary: [
      { day: 1, title: 'Kasheli', desc: 'Drive to Kasheli, visit the waterfalls, evening at Konkan homestay.' },
      { day: 2, title: 'Malvan & Sindhudurg', desc: 'Sindhudurg fort boat ride, afternoon snorkelling at Tarkarli.' },
      { day: 3, title: 'Devbagh & return', desc: 'Morning at Devbagh sangam then drive back to Pune.' }
    ],
    includes: ['Local transport from Pune', 'Coastal stay + breakfast', 'Boat rides', 'Trip captain'],
    excludes: ['Scuba diving fees', 'Travel to Pune', 'Personal expenses'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },
  {
    id: 'goa-trails',
    title: 'Goa Trails',
    location: 'Goa',
    duration: '4 Days / 3 Nights',
    price: 8499,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.7,
    reviews: 108,
    image: 'https://images.unsplash.com/photo-1486673748761-a8d18475c757?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1486673748761-a8d18475c757?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Beach',
    tag: 'Bestseller',
    short: 'A slow Goa loop \u2014 hidden South Goa beaches, Portuguese village walks, Old Goa churches and Divar island cycling.',
    highlights: ['Cola beach lagoon', 'Butterfly beach kayaking', 'Old Goa churches', 'Divar island cycling', 'Sao Jorge village walk', 'Spice plantation lunch'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Goa \u2192 Bengaluru', stay: '3 nights boutique stay', transport: 'Flight/Train + local Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Arrive Goa', desc: 'Check-in at Palolem, sunset beach walk.' },
      { day: 2, title: 'Hidden beaches', desc: 'Butterfly & Honeymoon beach kayak trip.' },
      { day: 3, title: 'Old Goa & Divar', desc: 'Churches by morning, Divar island cycling by afternoon.' },
      { day: 4, title: 'Departure', desc: 'Spice plantation lunch, transfer to airport.' }
    ],
    includes: ['Local transfers', '3 nights stay + breakfast', 'Cycle & kayak rental', 'Trip captain'],
    excludes: ['Flights/train to Goa', 'Water sports', 'Personal expenses'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },

  // ================= HISTORICAL =================
  {
    id: 'hampi',
    title: 'Hampi',
    location: 'Hampi, Karnataka',
    duration: '3 Days / 2 Nights',
    price: 6999,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.9,
    reviews: 96,
    image: 'https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
      'https://images.unsplash.com/photo-1656000599453-b33750b7e094?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Historical',
    tag: 'UNESCO',
    short: 'Bicycle across the boulder-strewn Vijayanagara empire \u2014 Virupaksha temple sunrise, Vitthala\u2019s stone chariot and coracle rides on the Tungabhadra.',
    highlights: ['Virupaksha temple', 'Vitthala stone chariot', 'Hemakuta hill sunset', 'Matanga hill sunrise', 'Coracle ride on Tungabhadra', 'Anegundi village walk'],
    tripInfo: { startingPoint: 'Bengaluru', route: 'Bengaluru \u2192 Hospet \u2192 Hampi \u2192 Bengaluru', stay: '2 nights riverside stay', transport: 'Overnight bus + local Tempo Traveller' },
    itinerary: [
      { day: 1, title: 'Arrival & sunset', desc: 'Reach Hampi, cycle to Hemakuta hill for sunset.' },
      { day: 2, title: 'Royal Enclosure & Vitthala', desc: 'Full-day heritage walk covering Vitthala, Lotus Mahal and Elephant Stables.' },
      { day: 3, title: 'Anegundi & return', desc: 'Morning coracle ride and Anegundi village walk before the overnight bus back.' }
    ],
    includes: ['Round-trip transport', 'Riverside stay + breakfast', 'Cycle rental', 'Heritage guide'],
    excludes: ['Lunches & dinners', 'Personal expenses', 'Insurance'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  },

  // ================= DEVOTIONAL =================
  {
    id: 'jyotirlinga-trails',
    title: 'Jyotirlinga Trails \u2014 Maharashtra 3',
    location: 'Nashik & Pune, Maharashtra',
    duration: '4 Days / 3 Nights',
    price: 9499,
    difficulty: 'Easy',
    groupSize: '6-14',
    rating: 4.9,
    reviews: 58,
    image: 'https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: [
      'https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'
    ],
    category: 'Devotional',
    tag: 'Pilgrimage',
    short: 'The three Jyotirlingas of Maharashtra in one guided pilgrimage \u2014 Trimbakeshwar at the source of the Godavari, Bhimashankar in the Sahyadris and Grishneshwar near Ellora.',
    highlights: ['Trimbakeshwar darshan', 'Bhimashankar sanctuary walk', 'Grishneshwar temple', 'Ellora caves stop', 'Godavari river aarti', 'Priest-guided rituals'],
    tripInfo: { startingPoint: 'Pune', route: 'Pune \u2192 Bhimashankar \u2192 Nashik \u2192 Trimbakeshwar \u2192 Aurangabad \u2192 Grishneshwar \u2192 Pune', stay: '3 nights hotel', transport: 'Tempo Traveller from Pune' },
    itinerary: [
      { day: 1, title: 'Pune \u2192 Bhimashankar', desc: 'Morning darshan and forest walk at Bhimashankar.' },
      { day: 2, title: 'Nashik & Trimbakeshwar', desc: 'Drive to Nashik, visit Trimbakeshwar and Godavari aarti in the evening.' },
      { day: 3, title: 'Grishneshwar & Ellora', desc: 'Drive to Aurangabad, darshan at Grishneshwar and Ellora caves visit.' },
      { day: 4, title: 'Return to Pune', desc: 'Morning at leisure and return to Pune by evening.' }
    ],
    includes: ['Local transport from Pune', '3 nights hotel + breakfast', 'Priest coordination for darshan', 'Trip captain'],
    excludes: ['Travel to Pune', 'Lunches & dinners', 'Special poojas', 'Personal expenses'],
    priceNote: 'Price for group travel with shared accommodation and transport. Final price may vary based on group size.'
  }
];

// Testimonials (kept for the Home page)
export const testimonials = [
  {
    name: 'Ananya Kapoor',
    location: 'Mumbai',
    tour: 'Bhairav Ghad & Gorakh Ghad',
    rating: 5,
    text: 'On Wheels made the Sahyadri feel like poetry. Our trip captain turned strangers into a family in one weekend. Zero corporate feel, pure hospitality.',
    avatar: 'https://api.dicebear.com/7.x/notionists/svg?seed=Ananya&backgroundColor=b6e3f4'
  },
  {
    name: 'Rahul Menon',
    location: 'Bengaluru',
    tour: 'Shivamogga & Sagara Trails',
    rating: 5,
    text: 'Third trip with On Wheels and every single detail was thought through \u2014 oxygen on treks, the local lunch at Sagara, even the playlist for the long drives.',
    avatar: 'https://api.dicebear.com/7.x/notionists/svg?seed=Rahul&backgroundColor=c0aede'
  },
  {
    name: 'Priya & Sameer',
    location: 'Pune',
    tour: 'Kasheli & Malvan',
    rating: 5,
    text: 'We travelled with our seven-year-old and On Wheels tailored every stop for her. Warm, honest, unhurried travel.',
    avatar: 'https://api.dicebear.com/7.x/notionists/svg?seed=Priya&backgroundColor=d1d4f9'
  },
  {
    name: 'Karan Singh',
    location: 'Delhi',
    tour: 'Waterfalls Trails',
    rating: 5,
    text: 'The Devkund plunge pool was surreal. Loved how On Wheels supported local homestays over hotel chains.',
    avatar: 'https://api.dicebear.com/7.x/notionists/svg?seed=Karan&backgroundColor=ffd5dc'
  }
];

// Home-page destinations grid
export const destinations = [
  { name: 'Sahyadri', trips: 3, image: 'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg' },
  { name: 'Karnataka', trips: 4, image: 'https://images.unsplash.com/photo-1660294534711-75a9474fecb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600' },
  { name: 'Konkan', trips: 3, image: 'https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600' },
  { name: 'Coast', trips: 3, image: 'https://images.unsplash.com/photo-1583212292454-1fe6229603b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600' },
  { name: 'Hampi', trips: 1, image: 'https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600' },
  { name: 'Jyotirlinga', trips: 1, image: 'https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600' }
];

export const stats = [
  { value: '100+', label: 'Happy Travellers' },
  { value: '3+', label: 'Curated Trips' },
  { value: '5', label: 'Categories' },
  { value: '4.8/5', label: 'Average Rating' }
];

// Kept for backward compatibility with imports; no separate short-trip cards anymore.
export const destinationCards = [];

export const heroImage = 'https://images.unsplash.com/photo-1504598318550-17eba1008a68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxyb2FkJTIwdHJpcHxlbnwwfHx8fDE3ODkyOTQ0NzB8MA&ixlib=rb-4.1.0&q=85';
